"use client";

import useUtility from "@/app/_hooks/useUtility";
import Link from "next/link";
import { useEffect } from "react";

export default function LegalPage({ page, pageSlug }) {
    // const { pageTitle } = useUtility();

    // useEffect(() => {
    //     pageTitle(page?.data?.page?.title || "Legal Page");
    // }, [pageTitle, page]);

    // console.log(page?.data?.related_pages?.data);
    return (
        <section className="privacy-policy-section section-bg pb-60">
            <span className="privacy-policy-shape one"></span>
            <span className="privacy-policy-shape two"></span>
            <span className="privacy-policy-shape three"></span>
            <div className="container">
                <div className="row">
                    {/* Sidebar */}
                    <div className="col-lg-4">
                        <div className="page-link-tab">
                            <h3 className="page-link-tab__title">Legal</h3>
                            <ul className="page-link-tab__list">
                                {page?.data?.related_pages?.data?.map(
                                    (link) => (
                                        <li
                                            key={link.slug}
                                            className={`page-link-tab__list-item ${
                                                link.slug === pageSlug
                                                    ? "active"
                                                    : ""
                                            }`}
                                        >
                                            <Link
                                                href={`${link.slug}`}
                                                className="page-link-tab__list-link"
                                            >
                                                {link.title}
                                            </Link>
                                        </li>
                                    )
                                )}
                            </ul>

                            <span className="page-link-tab__icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 167 167"
                                    fill="none"
                                >
                                    <path
                                        d="M130.469 55.668V70.2805C127.407 69.863 123.928 69.6542 120.031 69.5846V55.668C120.031 33.7492 113.838 19.1367 83.5 19.1367C53.1617 19.1367 46.9688 33.7492 46.9688 55.668V69.5846C43.0721 69.6542 39.5929 69.863 36.5312 70.2805V55.668C36.5312 35.4888 41.4021 8.69922 83.5 8.69922C125.598 8.69922 130.469 35.4888 130.469 55.668Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        opacity="0.4"
                                        d="M153.081 104.374V118.29C153.081 146.124 146.122 153.082 118.289 153.082H48.7057C20.8724 153.082 13.9141 146.124 13.9141 118.29V104.374C13.9141 81.1329 18.7849 72.435 36.5286 70.2779C39.5903 69.8604 43.0695 69.6516 46.9661 69.582H120.029C123.925 69.6516 127.404 69.8604 130.466 70.2779C148.21 72.435 153.081 81.1329 153.081 104.374Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M55.6615 118.284C54.7569 118.284 53.8523 118.075 53.0173 117.727C52.1127 117.379 51.4169 116.892 50.7211 116.266C49.4686 114.944 48.7031 113.135 48.7031 111.326C48.7031 110.421 48.9118 109.516 49.2597 108.681C49.6076 107.846 50.0949 107.081 50.7211 106.385C51.4169 105.759 52.1127 105.272 53.0173 104.924C55.5918 103.811 58.6535 104.437 60.6018 106.385C61.2281 107.081 61.7153 107.846 62.0632 108.681C62.4111 109.516 62.6198 110.421 62.6198 111.326C62.6198 113.135 61.8543 114.944 60.6018 116.266C59.2797 117.519 57.4706 118.284 55.6615 118.284Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M83.5052 118.287C81.6265 118.287 79.8869 117.521 78.5649 116.269C77.9386 115.573 77.4514 114.808 77.1034 113.973C76.7555 113.138 76.5469 112.233 76.5469 111.328C76.5469 109.45 77.3124 107.71 78.5649 106.388C81.1394 103.813 85.8014 103.813 88.4456 106.388C89.6981 107.71 90.4635 109.45 90.4635 111.328C90.4635 112.233 90.2549 113.138 89.907 113.973C89.5591 114.808 89.0718 115.573 88.4456 116.269C87.1235 117.521 85.3144 118.287 83.5052 118.287Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M111.333 118.287C109.524 118.287 107.715 117.521 106.393 116.269C105.14 114.947 104.375 113.207 104.375 111.328C104.375 109.45 105.14 107.71 106.393 106.388C109.037 103.813 113.699 103.813 116.274 106.388C116.552 106.736 116.83 107.084 117.109 107.501C117.387 107.849 117.596 108.267 117.735 108.684C117.944 109.102 118.083 109.519 118.153 109.937C118.222 110.424 118.292 110.911 118.292 111.328C118.292 113.138 117.526 114.947 116.274 116.269C114.952 117.521 113.143 118.287 111.333 118.287Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </span>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-lg-8">
                        <div className="privacy-policy-content">
                            <span className="privacy-policy-content__icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 167 167"
                                    fill="none"
                                >
                                    <path
                                        d="M130.469 55.668V70.2805C127.407 69.863 123.928 69.6542 120.031 69.5846V55.668C120.031 33.7492 113.838 19.1367 83.5 19.1367C53.1617 19.1367 46.9688 33.7492 46.9688 55.668V69.5846C43.0721 69.6542 39.5929 69.863 36.5312 70.2805V55.668C36.5312 35.4888 41.4021 8.69922 83.5 8.69922C125.598 8.69922 130.469 35.4888 130.469 55.668Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        opacity="0.4"
                                        d="M153.081 104.374V118.29C153.081 146.124 146.122 153.082 118.289 153.082H48.7057C20.8724 153.082 13.9141 146.124 13.9141 118.29V104.374C13.9141 81.1329 18.7849 72.435 36.5286 70.2779C39.5903 69.8604 43.0695 69.6516 46.9661 69.582H120.029C123.925 69.6516 127.404 69.8604 130.466 70.2779C148.21 72.435 153.081 81.1329 153.081 104.374Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M55.6615 118.284C54.7569 118.284 53.8523 118.075 53.0173 117.727C52.1127 117.379 51.4169 116.892 50.7211 116.266C49.4686 114.944 48.7031 113.135 48.7031 111.326C48.7031 110.421 48.9118 109.516 49.2597 108.681C49.6076 107.846 50.0949 107.081 50.7211 106.385C51.4169 105.759 52.1127 105.272 53.0173 104.924C55.5918 103.811 58.6535 104.437 60.6018 106.385C61.2281 107.081 61.7153 107.846 62.0632 108.681C62.4111 109.516 62.6198 110.421 62.6198 111.326C62.6198 113.135 61.8543 114.944 60.6018 116.266C59.2797 117.519 57.4706 118.284 55.6615 118.284Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M83.5052 118.287C81.6265 118.287 79.8869 117.521 78.5649 116.269C77.9386 115.573 77.4514 114.808 77.1034 113.973C76.7555 113.138 76.5469 112.233 76.5469 111.328C76.5469 109.45 77.3124 107.71 78.5649 106.388C81.1394 103.813 85.8014 103.813 88.4456 106.388C89.6981 107.71 90.4635 109.45 90.4635 111.328C90.4635 112.233 90.2549 113.138 89.907 113.973C89.5591 114.808 89.0718 115.573 88.4456 116.269C87.1235 117.521 85.3144 118.287 83.5052 118.287Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M111.333 118.287C109.524 118.287 107.715 117.521 106.393 116.269C105.14 114.947 104.375 113.207 104.375 111.328C104.375 109.45 105.14 107.71 106.393 106.388C109.037 103.813 113.699 103.813 116.274 106.388C116.552 106.736 116.83 107.084 117.109 107.501C117.387 107.849 117.596 108.267 117.735 108.684C117.944 109.102 118.083 109.519 118.153 109.937C118.222 110.424 118.292 110.911 118.292 111.328C118.292 113.138 117.526 114.947 116.274 116.269C114.952 117.521 113.143 118.287 111.333 118.287Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </span>
                            <h4 className="privacy-policy-content__title">
                                {page?.data?.page?.title}
                            </h4>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: page?.data?.page?.content || "",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
